import React from 'react';
import PropTypes from 'prop-types';

export const ProgressMeter = ({ currentStep, totalSteps, stepTitle, stepCount }) => {
	
	const progressMeterWidth = {
		width: `${(currentStep / totalSteps) * 100}%`
	}
	
	return (
		<div className="progressMeterContainer">
			<div className="progressMeter">
				<div 
					className="progressMeterIndicator"
					style={progressMeterWidth}
					role="progressbar"
					aria-valuenow={currentStep}
					aria-valuemin={1}
					aria-valuemax={totalSteps}
				></div>
			</div>
			{currentStep && totalSteps && stepTitle && 
				<div className="steps">
					<div className="stepProgress">{stepCount}</div>
					<div className="stepTitle">{`${stepTitle}`}</div>
				</div>
			}
		</div>
	)
}

ProgressMeter.propTypes = {
	currentStep: PropTypes.number,
	totalSteps: PropTypes.number,
	stepTitle: PropTypes.string,
	stepCount: PropTypes.string,
};



// WEBPACK FOOTER //
// ./buttons/components/progress/ProgressMeter.js